import { ReweighError } from '@shared/classes/error/reweigh-error';

export class InvalidLogHeaderIdError extends ReweighError {
  constructor(aMessage: string, aCause?: any) {
    super(aMessage, aCause); // call the parent constructor
  }
}
